// ENGLISH

export default {
    values: {
        'Type to search': 'Type to search',
        REMOVE: 'REMOVE',
        Creating: 'Creating',
        Create: 'Create',
        Close: 'Close',
        Cancel: 'Cancel',
        'Confirm deletion': 'Confirm deletion',
        'No, I do not': 'No, I do not',
        of: 'of',
        items: 'items',
        Default: 'Default',
        Ascending: 'Ascending',
        Descending: 'Descending',
        All: 'All',
        Description: 'Description',
        Name: 'Name',
        Save: 'Save',
        Asset: 'Asset',
        ASSET: 'ASSET',
        Responsible: 'Responsible',
        'Live Event Id': 'Live Event Id',
        Showing: 'Showing',

        /* ---------------------------------------------------------------------------------------------------------- */

        // FETCH ERROR
        'An error occurred on get operations.': 'An error occurred on get operations.',
        'An error occurred on create diagram.': 'An error occurred on create diagram.',
        'An error occurred on list bowties.': 'An error occurred on list bowties.',
        'An error occurred on get barrier status.': 'An error occurred on get barrier status.',
        'An error occurred on get bowtie.': 'An error occurred on get bowtie.',
        'Diagram saved successfully.': 'Diagram saved successfully.',
        'Error on save barrier.': 'Error on save barrier.',
        'Error on save bowtie.': 'Error on save bowtie.',
        'An error occurred on register supervisor': 'An error occurred on register supervisor',
        // END FETCH ERROR

        /* ---------------------------------------------------------------------------------------------------------- */

        // FETCH SUCCESSFULLY
        'Error on save diagram.': 'Error on save diagram.',
        'Barrier saved successfully.': 'Barrier saved successfully.',
        'Bowtie saved successfully.': 'Bowtie saved successfully.',
        // END FETCH SUCCESSFULLY

        /* ---------------------------------------------------------------------------------------------------------- */

        // BOWTIE GENERAL
        THREAT: 'THREAT',
        Threats: 'Threats',
        Threat: 'Threat',
        threat: 'threat',

        Barriers: 'Barriers',
        Bowties: 'Bowties',
        Diagrams: 'Diagrams',

        PREVENTION: 'PREVENTION',

        HAZARD: 'HAZARD',
        Hazard: 'Hazard',

        MITIGATION: 'MITIGATION',

        CONSEQUENCE: 'CONSEQUENCE',
        Consequences: 'Consequences',
        Consequence: 'Consequence',
        consequence: 'consequence',

        'Top Event': 'Top Event',
        'TOP EVENT': 'TOP EVENT',
        TOPEVENT: 'TOP EVENT',

        'Initial Freq.': 'Initial Freq.',
        'Final Freq.': 'Final Freq.',
        'Tolerable Freq.': 'Tolerable Freq.',
        'Threshold Freq.': 'Threshold Freq.',

        BARRIER: 'BARRIER',
        BARRIERS: 'BARRIERS',
        Barrier: 'Barrier',

        'Refresh Barriers': 'Refresh Barriers',

        'ESCALATION FACTOR': 'ESCALATION FACTOR',
        'Escalation Factor': 'Escalation Factor',
        'Escalation Factors': 'Escalation Factors',
        'Enabled degradation criterias:': 'Enabled degradation criterias:',

        Marine: 'Marine',
        Drilling: 'Drilling',
        Operation: 'Operation',
        Emergency: 'Emergency',
        marine: 'Marine',
        drilling: 'Drilling',
        operation: 'Operation',
        emergency: 'Emergency',

        'System ID': 'System ID',
        // END BOWTIE GENERAL

        /* ---------------------------------------------------------------------------------------------------------- */

        // RISK MANAGEMENT EDITOR
        Active: 'Active',
        'All Operations': 'All Operations',
        'Select Resource': 'Select Resource',
        RESOURCE: 'RESOURCE',
        'Leave without saving': 'Leave without saving',
        'ESCALATION BARRIER': 'ESCALATION BARRIER',
        'Barrier Category': 'Barrier Category',
        Criticality: 'Criticality',
        'LIST OF ENTITIES': 'LIST OF ENTITIES',
        OPERATION: 'OPERATION',
        'Risk Management': 'Risk Management',
        'Risk Diagram': 'Risk Diagram',
        'This action cannot be undone.': 'This action cannot be undone.',
        'Features that read this list will be affected.': 'Features that read this list will be affected.',
        'in the field below before completing the action:': 'in the field below before completing the action:',
        'Bowtie Editor': 'Bowtie Editor',
        'YOU DO NOT HAVE PERMISSION TO ACCESS THE EDITOR.': 'YOU DO NOT HAVE PERMISSION TO ACCESS THE EDITOR.',
        'YOU DO NOT HAVE PERMISSION TO ACCESS THE BOWTIE SETTINGS.':
            'YOU DO NOT HAVE PERMISSION TO ACCESS THE BOWTIE SETTINGS.',
        'Are you sure you want to leave without saving your work?':
            'Are you sure you want to leave without saving your work?', // eslint-disable-line max-len, prettier/prettier

        /// RISK MANAGEMENT EDITOR - DIAGRAMS LIST
        'New Diagram': 'New Diagram',
        'Create new diagram': 'Create new diagram',
        'There are no diagrams yet': 'There are no diagrams yet',
        'Are you sure you want remove the diagram': 'Are you sure you want remove the diagram',
        'If you really want to delete the diagram, type': 'If you really want to delete the diagram, type',
        'Delete diagram': 'Delete diagram',
        'diagram deleted.': 'Diagram deleted.',
        /// End RISK MANAGEMENT EDITOR - DIAGRAMS LIST

        /// RISK MANAGEMENT EDITOR - BARRIERS LIST
        'New Barrier': 'New Barrier',
        'Are you sure you want remove the barrier': 'Are you sure you want remove the barrier',
        'If you really want to delete the barrier, type': 'If you really want to delete the barrier, type',
        'Delete barrier': 'Delete barrier',
        'Load more': 'Load more',

        'barrier deleted.': 'Barrier deleted.',
        'Please insert a different name when copying barrier': 'Please insert a different name when copying barrier',
        /// End RISK MANAGEMENT EDITOR - BARRIERS LIST

        /// RISK MANAGEMENT EDITOR - BOWTIE LIST
        'New Bowtie': 'New Bowtie',
        'Create new Bowtie': 'Create new Bowtie',
        'There are no Bowties yet': 'There are no Bowties yet',
        'Are you sure you want remove the bowtie': 'Are you sure you want remove the bowtie',
        'If you really want to delete the bowtie, type': 'If you really want to delete the bowtie, type',
        'Delete bowtie': 'Delete bowtie',
        'bowtie deleted.': 'Bowtie deleted.',
        /// END RISK MANAGEMENT EDITOR - BOWTIE LIST

        /// RISK MANAGEMENT EDITOR - DIAGRAM EDITOR
        'A risk diagram must have at least one threat and at least one consequence':
            'A risk diagram must have at least one consequence and at least one threat',
        'Threat must have a valid name': 'Threat must have a valid name',
        'Consequence must have a valid name': 'Consequence must have a valid name',
        'must have a valid name': 'must have a valid name',
        'Threat must have a valid initial frequency': 'Threat must have a valid initial frequency',
        'must have a valid initial frequency': 'must have a initial frequency',
        'must have a valid threshold frequency': 'must have a valid threshold frequency',
        'Top event must have a valid name': 'Top event must have a valid name',
        'Hazard must have a valid name': 'Hazard must have a valid name',
        'Value Between 0 and 1': 'Value Between 0 and 1',
        'Initial Frequency': 'Initial Frequency',
        'Final Frequency': 'Final Frequency',
        /// END RISK MANAGEMENT EDITOR - DIAGRAM EDITOR

        /// RISK MANAGEMENT EDITOR - BARRIER EDITOR
        'Please select barrier category and barrier': 'Please select barrier category and barrier',
        'Entities with errors': 'Entities with errors',
        'Barrier Update Mode': 'Barrier Update Mode',
        Method: 'Method',
        Quantitative: 'Quantitative',
        Qualitative: 'Qualitative',
        'Initial PFD': 'Initial PFD',
        'Final PFD': 'Final PFD',
        'NORMALIZATION TITLE': 'QUANTIZATION',
        'add escalation': 'add escalation',
        Deadline: 'Deadline',
        'Manual barrier is on indefinitely unless deadline is set.':
            'Manual barrier is on indefinitely unless deadline is set.',
        'Manual Barrier Status Interaction': 'Manual Barrier Status Interaction',
        'External Related Links': 'External Related Links',
        Label: 'Label',
        'Add Link': 'Add Link',
        /// END RISK MANAGEMENT EDITOR - BARRIER EDITOR

        /// RISK MANAGEMENT EDITOR - BOWTIE EDITOR
        'Safety Critical Barrier (Optional)': 'Safety Critical Barrier (Optional)',
        'Bowtie Mandatory Barrier': 'Bowtie Mandatory Barrier (Pre-Operational)',
        'Threat Mandatory Barrier': 'Threat Mandatory Barrier',
        'Consequence Mandatory Barrier': 'Consequence Mandatory Barrier',
        'Once The Threat Mandatory Barrier option is selected the inactivation of it will lead to the inactivation of the whole Bowtie Web that it belongs. \nOnce The Bowtie Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite':
            'Once The Threat Mandatory Barrier option is selected the inactivation of it will lead to the inactivation of the whole Bowtie Web that it belongs \nOnce The Bowtie Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite',
        'Once The Consequence Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite':
            'Once The Consequence Mandatory Barrier option is selected the inactivation of it will lead to the Top Event Occurrence directly, because it is an operational prerequisite',
        'Changes made in this interface will occur just in this Bowtie':
            'Changes made in this interface will occur just in this Bowtie',
        /// END RIS MANAGEMENT EDITOR - BOWTIE EDITOR
        // END RISK MANAGEMENT EDITOR

        /* ---------------------------------------------------------------------------------------------------------- */

        // BOWTIE VISUALIZATION
        'Degraded Barriers': 'Degraded Barriers',
        'active barriers': 'active barriers',
        'Inactive Barriers': 'Inactive Barriers',
        'Effectiveness Top': 'Effectiveness Top',
        'Effectiveness Bottom': 'Effectiveness Bottom',
        'Refers to the quantity of barriers with any degradation (including the inactive ones).':
            'Refers to the quantity of barriers with any degradation (including the inactive ones).',
        'Refers to the % of barriers that are not inactive and/or unknown status.':
            'Refers to the % of barriers that are not inactive and/or unknown status.',
        'No event': 'No event',
        // END BOWTIE VISUALIZATION

        /* ---------------------------------------------------------------------------------------------------------- */

        /* OVERVIEW */
        Intolerable: 'Intolerable',
        'degraded barriers': 'degraded barriers',
        degraded: 'degraded',
        Degraded: 'Degraded',
        Inactive: 'Inactive',
        inactive: 'inactive',
        INACTIVE: 'INACTIVE',
        active: 'active',
        MANAGER: 'MANAGER',
        Unknown: 'Unknown',
        'BOWTIES WITH DEGRADED BARRIERS': 'BOWTIES WITH DEGRADED BARRIERS',
        'Go to bowtie editor': 'Go to bowtie editor',
        Acceptable: 'Acceptable',
        Tolerable: 'Tolerable',
        Unacceptable: 'Unacceptable',
        'Invalid event': 'Invalid event',
        'inactive barriers': 'inactive barriers',
        'This is a custom client overview. It does not follow the original product standard.':
            'This is a custom client overview. It does not follow the original product standard.',
        Evidences: 'Evidences',
        /* END OVERVIEW */

        /* HELP MODAL */
        Help: 'Help',
        'Bowtie interaction': 'Bowtie interaction',
        'human barrier': 'human barrier',
        'physical barrier': 'physical barrier',
        'administrative barrier': 'administrative barrier',
        'High criticality': 'High criticality',
        'Toggle language': 'Toggle language',
        'Open help modal': 'Open help modal',
        'Highlight inactive and unknown barriers': 'Highlight inactive and unknown barriers',
        'Open first barriers level': 'Open first barriers level',
        'Close all barriers': 'Close all barriers',
        'Reset zoom and position': 'Reset zoom scale and position',
        'Zoom in': 'Zoom in',
        'Zoom out': 'Zoom out',
        'Reset zoom': 'Reset zoom',
        'Edit this bowtie': 'Edit this bowtie',
        Search: 'Search',
        Settings: 'Settings',

        /** SETTINGS */
        'Alarp Description':
            'ALARP stands for "as low as reasonably practicable" and it is directly related to the Residual Risk. ALARP shows a picture of the safety level that\'s been considered at that time and it is a tolerance level definition: unacceptable, tolerable and totally acceptable.',
        'Quantitative Description':
            'Quantitative method: Quantitative data is used to quantify a problem by numbers. This data can be counted or compared on a numerical scale. The quantitative method contains numbers to quantify the PFD - Probability of Failure on Demand, based on the relative value of Initial PFD.',
        'Qualitative Description':
            'Qualitative method: qualitative data can be defined as non-numerical data, boolean approach or percentual. The qualitative method output of the process is goint to be a degradation status based on boolean criterias.',
        'Absolute Quantitative Description':
            'Quantitative data is used to quantify a problem by numbers. This data can be counted or compared on a numerical scale. The quantitative method contains numbers to quantify the PFD - Probability of Failure on Demand (Initial, Final and Threshold)',
        'QUALITATIVE METHOD': 'Qualitative Method',
        'QUANTITATIVE METHOD': 'Quantitative Method',
        'NORMALIZATION METHOD':
            'Qualitative barrier in a Quantitative Bowtie (Hybrid Bowtie) is a qualitative barrier inserted in a plot, or branch or in a Bowie of Quantitative barriers. The qualitative barrier has a subjective value to assess its status. This subjective value called effectiveness (QLR) is quantified in a demand probability value (PFD) from the configuration settings given by the user.',
        CATEGORY_UNMONITORED_DESCRIPTION:
            'This category corresponds to barriers that are not monitored (generally by third parties) either by sensor, by event, manually or other updating method. That is, the user does not receive any data updates in real-time.',
        ICON: 'ICON',
        CATEGORY: 'CATEGORY',
        DESCRIPTION: 'DESCRIPTION',
        AUTHOR: 'AUTHOR',
        'LAST CHANGED': 'LAST CHANGED',
        'New Category': 'New Category',
        'Barrier Categories': 'Barrier Categories',
        'Alarp Levels': 'Alarp Levels',
        Color: 'Color',
        'Highest acceptable level of risk': 'Highest acceptable level of risk',
        'Generally acceptable level of risk': 'Generally acceptable level of risk',
        'Risk Rate': 'Risk Rate',
        'New Rule': 'New Rule',
        Unmonitored: 'Unmonitored',
        'Unmonitored Description':
            'PS: As an unmonitored barrier, this category does not require a status calculation. For this reason, it will not be possible to configure business rules and the fields related to PFD intervals will be disabled in the interface. They will have a unique status, which will receive the same name as the category, along with a specific color for their identification.',

        /** REPORTS **/
        SETTINGS: 'SETTINGS',
        PRESETS: 'PRESETS',
        'Risk Acceptance / Risk Level': 'Risk Acceptance / Risk Level',
        'Resource Threat Status': 'Resource Threat Status',
        'Resource Barrier Status': 'Resource Barrier Status',
        'Resource Barrier PFD': 'Resource Barrier PFD',
        'Current Mandatory Barriers': 'Current Mandatory Barrier',
        'Manual Interaction Barriers Status': 'Manual Interaction Barrier Status',
        TIMESPAN: 'TIMESPAN',
        'SELECT THE TIMESPAN': 'SELECT THE TIMESPAN',
        Start: 'Start',
        End: 'End',
        to: 'to',
        resource: 'resource',
        'bowtie code': 'bowtie code',
        'bowtie name': 'bowtie name',
        'risk level status': 'risk level status',
        'date/time': 'date/time',
        'YYYY/MM/DD': 'YYYY/MM/DD',
        'threat name': 'threat name',
        'inherent risk': 'inherent risk',
        Yesterday: 'Yesterday',
        'Last day': 'Last day',
        'Last 15 days': 'Last 15 days',
        'Last week': 'Last week',
        'Last month': 'Last month',
        'Last quarter': 'Last quarter',
        'Last semester': 'Last semester',
        'Last year': 'Last year',
        Apply: 'Apply',
        Clear: 'Clear',
        page: 'page',
        'All time': 'All time',
        'Select a preset and a time range to view a report': 'Select a preset and a timespan to view a report',
        'initial frequency': 'initial frequency',
        'final frequency': 'final frequency',
        'barrier id': 'barrier id',
        'barrier name': 'barrier name',
        'safety critical': 'safety critical',
        responsible: 'responsible',
        'Selected filters': 'Selected filters',
        'Clear  all': 'Clear  all',
        category: 'category',
        'entity name': 'entity name',
        'initial pfd': 'initial pfd',
        'final pfd': 'final pfd',
        threshold: 'threshold',
        'Threshold Frequency': 'Threshold Frequency',
        'PFD max': 'PFD max',
        'Lowly degraded': 'L.Degraded',
        LOW_DEGRADED: 'L.DEGRADED',
        HIGHLY_DEGRADED: 'H.DEGRADED',
        UNMONITORED: 'UNMONITORED',
        HIGH_DEGRADED: 'H.DEGRADED',
        'Highly degraded': 'H.Degraded',
        unmonitored: 'não monitorada',
        'Resource Barrier Analysis': 'Resource Barrier Analysis',
        'time interval': 'time interval',
        'time gathered': 'time gathered',
        'Select an item from the list to view the graphic': 'Select an item from the list to view the graphic',
        Graphic: 'Graphic',
        END: 'END',
        START: 'START',
        'Time Interval': 'Time interval',

        /** System audit */
        'An error occurred on listing audit logs': 'An error occurred on listing audit logs',
        'No data for the selected period. Select a different timespan and try again.':
            'No data for the selected period. Select a different timespan and try again.',
        Download: 'Download',
        'DOWNLOAD DATA': 'DOWNLOAD DATA',
        Successful: 'Successful',
        Error: 'Error',
        'Client Error': 'Client Error',
        'Server Error': 'Server Error',
        Redirection: 'Redirection',
        Informational: 'Informational',
        'Request Method': 'Request Method',
        'Please, enter a time range': 'Please, enter a time range',
        'An error occurred on export data': 'An error occurred on export data',

        /** END */
        'Restore defaults': 'Restore defaults',
        'PDF export only shows the latest 300 requisitions': 'PDF export only shows the latest 300 requisitions',
        'Server response': 'Server response',
        'Server payload': 'Server payload'
    }
}
